export const LOGIN_I18N_PREFIX = "features.login.login";

export const LOGIN_I18N_KEYS = {
  password_reset_email_sent:          "password_reset_email_sent",
  error_sending_password_reset_email: "error_sending_password_reset_email",
};


// WEBPACK FOOTER //
// ./src/features/login/constants/i18n/Logini18nConstants.js